import { filter, get, includes, keys, size, some } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getSelectedIntervalAvailability } from '../../selectors/availability';
import { getSelectedCityEnterprises } from '../../selectors/views/selectedCityEnterprises';
import { AvailabilityValue } from '../../types/data';
import { isVoucherDirty } from '../resourceOrder/selectors';
import {
    hasSelectedCityServiceAvailabilityFailed,
    isSelectedCityServiceAvailabilityFetching,
} from './serviceAvailability';

const getAvailabilityFilteredByEnterpriseIds = (availabilityValues: AvailabilityValue[], enterpriseIds: string[]) =>
    filter(({ enterpriseId }) => includes(enterpriseId, enterpriseIds), availabilityValues);

const getSelectedCityAvailability = createSelector(
    getSelectedCityEnterprises,
    getSelectedIntervalAvailability,
    (enterprises, intervalAvailability) =>
        getAvailabilityFilteredByEnterpriseIds(intervalAvailability, keys(enterprises))
);

// @ts-expect-error $TSFixMeError: Argument of type 'LodashGet1x1<AvailabilityValue, "isFetching">' is not assignable to parameter of type 'ValueIterateeCu...
export const isSelectedCityAvailabilityFetching = createSelector(getSelectedCityAvailability, some(get('isFetching')));
// @ts-expect-error $TSFixMeError: Argument of type 'LodashGet1x1<AvailabilityValue, "hasFailed">' is not assignable to parameter of type 'ValueIterateeCus...
export const hasSelectedCityAvailabilityFailed = createSelector(getSelectedCityAvailability, some(get('hasFailed')));

export const shouldGetSelectedCityAvailability = createSelector(
    isSelectedCityAvailabilityFetching,
    isSelectedCityServiceAvailabilityFetching,
    hasSelectedCityAvailabilityFailed,
    hasSelectedCityServiceAvailabilityFailed,
    isVoucherDirty,
    getSelectedCityAvailability,
    (
        isFetching,
        isServiceAvailabilityFetching,
        hasFailed,
        hasServiceAvailabilityFailed,
        voucherDirty,
        cityAvailability
    ) =>
        !isFetching &&
        !isServiceAvailabilityFetching &&
        (size(cityAvailability) === 0 || hasFailed || hasServiceAvailabilityFailed || voucherDirty)
);
